import React from "react";

interface CheckboxProps {
  label?: string;
  className?: string;
  labelHtml?: React.ReactNode;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  id?: string;
  disabled?: boolean;
  labelClassName?: string;
  removeCheckMargin?: boolean;
}

const Checkbox: React.FC<CheckboxProps> = ({
  label,
  checked,
  onChange,
  id,
  disabled,
  labelHtml,
  className,
  labelClassName,
  removeCheckMargin = false,
}) => {
  const cursorClass = disabled ? "cursor-not-allowed" : "cursor-pointer";
  return (
    <div className={` ${className} inline-flex  items-start sm:items-center`}>
      <label
        className={`flex items-center ${cursorClass} relative`}
        htmlFor={id}
      >
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          className={`peer h-5 sm:h-6 w-5 sm:w-6 ${cursorClass} ${
            removeCheckMargin ? null : "sm:mt-[-10px]"
          }  transition-all appearance-none rounded shadow hover:shadow-md border border-primary checked:bg-primary checked:border-primary`}
          id={id}
          disabled={disabled}
        />
        <span
          className={`absolute top-1/2 ${
            removeCheckMargin ? "sm:top-[50%]" : "sm:top-[16%]"
          }  left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none
          bg-lightGold peer-checked:bg-primary peer-checked:border-primary
          peer-checked:text-white peer-checked:opacity-100 opacity-0 
          border-lightGold rounded-full`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="1"
          >
            <path
              fillRule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clipRule="evenodd"
            ></path>
          </svg>
        </span>
      </label>
      <label
        className={`${cursorClass} ml-2 text-[14px] sm:text-[16px] font-Mulish text-[#98A2B3] ${labelClassName} `}
        htmlFor={id}
      >
        {label
          ? label.charAt(0).toUpperCase() + label.slice(1).toLowerCase()
          : labelHtml}
      </label>
    </div>
  );
};

export default Checkbox;
